import { Grid, Paper, MenuList, MenuItem } from '@mui/material';
import TestIds from 'Tests/TestIds';
import PersonAvatar from 'Theme/components/Avatar/PersonAvatar';
import { useStyles } from '../../SearchBars.styles';
import { userFullName } from 'Tools/LabelFormatter/userFullName';
import useTranslate from 'Hooks/useTranslate';

interface IHighlightProps {
  readonly text: string;
  readonly search: string;
}

function Highlight({ text, search }: IHighlightProps) {
  if (!search) {
    return <>{text}</>;
  }
  const regex = new RegExp(`(${search})`, 'gi');
  const parts = text.split(regex);
  const lowerSearch = search.toLocaleLowerCase();

  console.log('parts', parts);
  return (
    <>
      {parts.map((part, index) =>
        part.toLocaleLowerCase() === lowerSearch ? (
          <b key={`${part}-${index}`}>{part}</b>
        ) : (
          <span key={`${part}-${index}`}>{part}</span>
        )
      )}
    </>
  );
}

interface Props {
  currentSearch: string;
  currentUserSelected?: string;
  data: IPaginatedList<ILightPersonAccessRight> | undefined;
  onChooseUser(value: ILightPersonProfile): void;
}

const AvailabledResult = (props: Props) => {
  const { data, onChooseUser, currentUserSelected, currentSearch } = props;
  const ts = useTranslate();
  const classes = useStyles();

  return (
    <Grid
      item
      data-testid={TestIds.component.searchByUser.resultList}
      xs={12}
      className={classes.resultList}
    >
      <Paper elevation={2}>
        <MenuList>
          {data?.edges.map((elt, i: number) => {
            let userFirstName = elt.node.personProfile?.firstName;
            let userLastName = elt.node.personProfile?.lastName;
            let fullN = userFullName(userFirstName, userLastName);
            let userEmail = elt.node.personProfile?.email;

            let requestsCount = ts(
              'component.accessrights.pendingRequest.count',
              {
                value: elt.node.countAccessRequests
              }
            );

            return (
              <MenuItem
                key={elt.node.personProfile.email}
                onClick={() => onChooseUser(elt.node.personProfile)}
                selected={
                  elt.node.personProfile?.immutableId === currentUserSelected
                }
                data-testid={`${TestIds.component.searchByUser.totalRequestOnUser}-${i}`}
              >
                <PersonAvatar
                  person={{ ...elt.node.personProfile }}
                  size={'small'}
                  className={classes.userAvatar}
                />
                <div className={classes.overflow}>
                  <Highlight text={fullN ?? ''} search={currentSearch} />
                  {' · '}
                  {requestsCount}
                  {' · '}
                  <Highlight text={userEmail ?? ''} search={currentSearch} />
                </div>
              </MenuItem>
            );
          })}
        </MenuList>
      </Paper>
    </Grid>
  );
};

export default AvailabledResult;
